import React from "react";
import {
  getLabelTagInput,
  getLabelTagYesNO,
} from "../../../../IpEMR/InspectionSummaries/constructTextFromValues";
import { Descriptions } from "antd";

const PastSurgicalHistory = ({ data }) => {
  return (
    <div>
      <Descriptions bordered={false}>
        <Descriptions.Item>
          {data && getLabelTagYesNO(data?.surgical_history)}
          {data && getLabelTagInput("Details", data?.surgical_history_details)}
        </Descriptions.Item>
      </Descriptions>
    </div>
  );
};

export default PastSurgicalHistory;
